const STRINGS = {
	copyright: gettext('Copyright'),
	surveyMonkey: gettext('SurveyMonkey'),
	privacy: gettext('Privacy'),
	terms: gettext('Terms'),
	help: gettext('Help'),
	closeAlert: gettext('Close alert'),
};

export default STRINGS;
